<template>
  <div>
    <transition name="overlay-fade">
      <div class="overlay-message" v-show="updateOk">
        <p class="system-text">Uw wachtwoord is aangepast.</p>
      </div>
    </transition>
    <close-button @click="$emit('close')" class="close-button"></close-button>

    <div class="dialog-header">
      <h1>Nieuw wachtwoord</h1>
    </div>
    <div class="dialog-content">
      <p>
        Voer hieronder uw nieuwe wachtwoord in. Uw nieuwe wachtwoord dient uit
        minimaal 12 karakters te bestaan, waarvan 1 hoofdletter en 1 cijfer.
      </p>
      <div>
        <div class="reset-form">
          <form
            name="resetForm"
            method="post"
            action="/reset"
            @submit.prevent="savePassword"
            autocomplete="new-password"
          >
            <input
              class="username"
              type="text"
              :value="user"
              name="username"
              autocomplete="username"
            />
            <div class="field-wrapper">
              <div class="label-fix">
                <label for="newPass">Wachtwoord</label>
                <div>
                  <password-input
                    v-model="newPass"
                    :password="newPass"
                    :show-hint="false"
                    :invalid="v$.newPass.$invalid"
                    :autocomplete="'new-password'"
                  ></password-input>
                </div>
              </div>
            </div>

            <div class="message error-text">
              <p v-show="error" class="error-text">
                Uw nieuwe wachtwoord kon niet worden bewaard. Dit kan komen
                doordat de link die u gebruikt verlopen is. Wij raden u aan deze
                opnieuw aan te vragen.
              </p>
            </div>
            <div class="button-holder">
              <button
                class="pill-button save-pw"
                type="submit"
                :disabled="v$.$invalid || prevSubmit"
              >
                Wachtwoord bewaren
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'

import { required } from '@vuelidate/validators'
import { updatePassword } from '@/api/api'
import PasswordInput from '@/components/ui/PasswordInput.vue'
import { vuelidatePasswordPattern } from '@/api/passwords'

export default {
  setup() {
    const v$ = useVuelidate()
    return { v$ }
  },
  components: { PasswordInput },
  data() {
    return {
      newPass: '',
      password2: '',
      error: false,
      message: '',
      updateOk: false,
      prevSubmit: false,
      user: this.$route.query.e || ''
    }
  },

  methods: {
    savePassword() {
      const id = this.$route.query.i || ''
      const username = this.$route.query.e || ''
      this.prevSubmit = true

      updatePassword(username, id, this.newPass)
        .then(() => {
          this.updateOk = true
          setTimeout(() => {
            this.$emit('close')
          }, 2000)
        })
        .catch((err) => {
          this.error = true
          this.message =
            'Uw nieuwe wachtwoord kon niet worden bewaard. Dit kan komen doordat de link die u gebruikt verlopen is. Wij raden u aan deze opnieuw aan te vragen.'
          setTimeout(() => {
            this.$emit('close')
          }, 7000)
        })
    }
  },
  validations: {
    newPass: {
      required,
      vuelidatePasswordPattern
    }
  }
  /*   computed: {
    passSet() {
      return (
        this.password1 === this.password2 && this.password1.match(passwordRegex)
      )
    }
  } */
}
</script>

<style lang="scss" scoped>
.button-holder {
  padding-top: 10px;
}

label {
  line-height: 34px;
}

.pass-info {
  margin: 10px 0 -10px;
  line-height: 15px;
}

.field-wrapper {
  margin: 5px 0 15px;
}

.username {
  display: none;
}

.save-pw {
  //  width: 200px;
  //  margin-bottom: 10px;
}
</style>
